import { baseReducerState, BaseReducerState } from "Store/Shared/Store/PropTypes";

export type VacancyId = string;

export interface VacancyState extends BaseReducerState<VacancyId> {
    unsaved: {},
    saved: {},
    new: '',
    createFlowId: string | null
}

export const initialVacancyState: VacancyState = {
    ...baseReducerState,
    unsaved: {},
    saved: {},
    new: '',
    createFlowId: null
}